<div class="wrapper">
  <div class="container px-0">
    <!--<h5 class="main-title">{{patientpersonalinfo.PracticeName}}</h5>
    <div class="main-info">
      {{'insurances.insurances_insurance'|translate}}
    </div>-->
    <!--New design-->
    <div class="main-wrapper">
      <ng-container *ngIf="addInsurance">
        <div class="container flex-grow-1">
          <!-- <span class="text-default">Best Practice <span class="small">1 of 12</span> </span> -->

          <div class="insurance-tab">
            <div class="row">
              <div class="col-md-12">
                <h5 class="inTitle mb-4 ">{{'insurances.insurance_uploadcard_title'|translate}}</h5>

                <div class="form-label padding-left fw-bold mt-2" style="margin-bottom:10px">
                  {{'insurances.insurancetype'|translate}}
                </div>
                <div class="form-group mb-2">
                  <div class="row">
                    <div class="col-12 d-flex flex-wrap justify-content-between mb-2">
                      <div class="custom-control custom-radio mb-1">
                        <input type="radio" id="primary" name="insuranceType" class="custom-control-input" (change)="selectInsurance($event)" [(ngModel)]="insurancecat" value="P">
                        <label class="custom-control-label" for="primary">{{'insurances.insurances_insurance_type_primary'|translate}}</label>
                      </div>

                      <div class="custom-control custom-radio mb-1">
                        <input type="radio" id="secondary" name="insuranceType" class="custom-control-input" (change)="selectInsurance($event)" [(ngModel)]="insurancecat" value="S">
                        <label class="custom-control-label" for="secondary">{{'insurances.insurances_insurance_type_secondary'|translate}}</label>
                      </div>

                      <div class="custom-control custom-radio mb-1">
                        <input type="radio" id="other" name="insuranceType" class="custom-control-input" (change)="selectInsurance($event)" [(ngModel)]="insurancecat" value="O">
                        <label class="custom-control-label" for="other">{{'insurances.insurances_insurance_type_other'|translate}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Capture card  -->

              <div *ngIf="AddinsuranceBycard" class="container flex-grow-1 overflow-auto">
                <div class="row">
                  <div class="col-12">
                    <h5 class=" text-center mb-4 ">{{'insurances.insurance_take_photo_title'|translate}}</h5>
                    <div class="row text-center">
                      <div class="col-md-6">
                        <!-- <div class="mb-4"><img class="img-fluid" src="assets/images/card-front.png"></div> -->
                        <div class="mb-4 pb-2 border-bottom">
                          <!--<div *ngIf="isFrontPhotoUpload" class="mb-4"><img class="img-fluid" [src]="defaultImagefront" height="155" width="231"></div>-->
                          <button type="button" class="btn btn-sm upload-btn px-0">
                            <input type="file" id="file" class="d-none" (change)="onChangeFileFront($event)"
                                   accept="image/png, image/gif, image/jpeg,image/jpg">
                            <label for="fileFront">
                              <span class="file-button d-flex flex-column align-items-center">
                                <svg *ngIf="!isFrontPhotoUpload" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z" fill="black" />
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.75 11.25H41.25C42.0263 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0263 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z" fill="black" />
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.625H17.0963C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9912C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65187 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562C42.6562 29.4431 42.6562 19.2188 42.6562 19.2188C42.6562 18.4425 42.0263 17.8125 41.25 17.8125C40.4737 17.8125 39.8438 18.4425 39.8438 19.2188V35.1562C39.8438 35.7787 39.5963 36.3731 39.1575 36.8138C38.7169 37.2525 38.1225 37.5 37.5 37.5H7.5C6.8775 37.5 6.28312 37.2525 5.8425 36.8138C5.40375 36.3731 5.15625 35.7787 5.15625 35.1562V16.4062C5.15625 15.1125 6.20625 14.0625 7.5 14.0625H11.9662C13.2094 14.0625 14.3456 13.3594 14.9006 12.2494L16.6763 8.69625C16.7569 8.53875 16.9181 8.4375 17.0963 8.4375H26.25C27.0263 8.4375 27.6562 7.8075 27.6562 7.03125C27.6562 6.255 27.0263 5.625 26.25 5.625Z" fill="black" />
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 15.9375C17.5838 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5838 33.75 22.5 33.75C27.4162 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4162 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z" fill="black" />
                                </svg>
                                <div *ngIf="isFrontPhotoUpload" class="mb-4"><img class="img-fluid" [src]="defaultImagefront" height="155" width="231"></div>
                                <span *ngIf="!isFrontPhotoUpload" class="text-muted mt-2">
                                  {{'insurances.insurances_capture_add_card_front'|translate}}
                                </span>
                                <span *ngIf="isFrontPhotoUpload" class="text-muted mt-2">
                                  {{'insurances.insurance_take_photo_Retakefront'|translate}}
                                </span>
                              </span>

                            </label>
                          </button>
                          <div class="err" *ngIf="isRequireFrontCard">{{'insurances.insurances_capture_add_card_front_is_required'|translate}}</div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-4 pb-2 border-bottom">

                          <!--<div *ngIf="isbackPhotoUpload" class="mb-4"><img class="img-fluid" [src]="defaultImageback" height="155" width="231"></div>-->
                          <button type="button" class="btn btn-sm upload-btn px-0">
                            <input type="file" id="file" class="d-none" (change)="onChangeFileBack($event)"
                                   accept="image/png, image/gif, image/jpeg,image/jpg">
                            <label for="fileBack" #fileBack>
                              <span class="file-button d-flex flex-column align-items-center">
                                <svg *ngIf="!isbackPhotoUpload" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z" fill="black" />
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.75 11.25H41.25C42.0263 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0263 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z" fill="black" />
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.25 5.625H17.0963C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9912C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65187 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562C42.6562 29.4431 42.6562 19.2188 42.6562 19.2188C42.6562 18.4425 42.0263 17.8125 41.25 17.8125C40.4737 17.8125 39.8438 18.4425 39.8438 19.2188V35.1562C39.8438 35.7787 39.5963 36.3731 39.1575 36.8138C38.7169 37.2525 38.1225 37.5 37.5 37.5H7.5C6.8775 37.5 6.28312 37.2525 5.8425 36.8138C5.40375 36.3731 5.15625 35.7787 5.15625 35.1562V16.4062C5.15625 15.1125 6.20625 14.0625 7.5 14.0625H11.9662C13.2094 14.0625 14.3456 13.3594 14.9006 12.2494L16.6763 8.69625C16.7569 8.53875 16.9181 8.4375 17.0963 8.4375H26.25C27.0263 8.4375 27.6562 7.8075 27.6562 7.03125C27.6562 6.255 27.0263 5.625 26.25 5.625Z" fill="black" />
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 15.9375C17.5838 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5838 33.75 22.5 33.75C27.4162 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4162 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z" fill="black" />
                                </svg>
                                <div *ngIf="isbackPhotoUpload" class="mb-2"><img class="img-fluid" [src]="defaultImageback" height="155" width="231"></div>
                                <span *ngIf="!isbackPhotoUpload" class="text-muted mt-2">
                                  {{'insurances.insurances_capture_add_card_back'|translate}}
                                </span>
                                <span *ngIf="isbackPhotoUpload" class="text-muted mt-2">
                                  {{'insurances.insurance_take_photo_RetakeBack'|translate}}
                                </span>
                              </span>
                            </label>
                          </button>
                          <div class="err" *ngIf="isRequireBackCard">{{'insurances.insurances_capture_add_card_back_is_required'|translate}}</div>
                        </div>
                      </div>

                    </div>
                    <div class="text-center" style="font-size:18px">
                      <button class="btn btn-primary btncare" (click)="checkIsAlreadyPhotoUpload()">{{'insurances.add_insurance'|translate}}</button>
                    </div>
                    <div class="devider mb-4">
                      <span>{{'insurances.insurance_or'|translate}}</span>
                    </div>
                    <div class="text-center" style="font-size:18px">
                      <button class="btn btn-primary btncare mb-4" (click)="addInsuranceManuallyNew()"> {{'insurances.insurances_add_insurance_manually'|translate}}</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>


            <div *ngIf="addInsurancemanually">
              <div class="row">
                <div class="form-group col-md-12">

                  <!--<div class="text-right" style="margin-bottom:10px">
                    <a class="mr-auto text-center" (click)="scanCard()">Scan Your Insurance Card</a>
                  </div>-->

                  <div class=" mb-2 border-bottom">
                    <label class="form-label padding-left fw-bold">{{'insurances.insurances_insurance'|translate}}<span class="text-danger">*</span></label>
                    <div class="input-group">
                      <div class="dropdown input-icon search" ngbDropdown
                           #insuranceDropPopUp="ngbDropdown" style="flex: 2;">
                        <input placeholder="{{'insurances.insurances_insurance_placeholder'|translate}}" autocomplete="off"
                               class="form-control text-left text-capitalize border-0 ltr-component" type="text"
                               id="dropdownMenu2" aria-haspopup="true" aria-expanded="false"
                               [(ngModel)]="insuranceNamePopup"
                               (input)="PatientInsuranceSearch($event,'popup')" ngbDropdownAnchor
                               (focus)="insuranceDropPopUp.open()">


                        <div ngbDropdownMenu class="custom-menu" aria-labelledby="dropdownMenu2"
                             [ngClass]="{'d-none': dNoneInsurance}">
                          <button ngbDropdownItem *ngIf="isLoading">
                            <span>{{'insurances.insurances_insurance_loading'|translate}}</span>
                          </button>
                          <button ngbDropdownItem
                                  *ngIf="!isInsuranceData && !isLoading">
                            {{'insurances.insurances_insurance_placeholder'|translate}}
                          </button>
                          <button ngbDropdownItem
                                  *ngIf="filterInsuranceSearch?.length === 0 && !isLoading && isInsuranceData">
                            {{'insurances.insurances_insurance_no_records_found'|translate}}
                          </button>
                          <button ngbDropdownItem *ngFor="let items of filterInsuranceSearch"
                                  (click)="SetInsuranceSearch(items.inspayeR_DESCRIPTION,'popup')">
                            <span class="text-capitalize">
                              {{items.inspayeR_DESCRIPTION | lowercase }}
                            </span><br />
                            <span class="text-capitalize">
                              {{items.insurancE_ADDRESS|lowercase}}
                            </span> <br />
                            <span class="text-capitalize">
                              {{items.insurancE_CITY |lowercase}}, {{items.insurancE_STATE}}
                              {{items.insurancE_ZIP.substring(0, 5)}}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                  <span class="err" id="ins-filter-err" *ngIf="insuranceNameError">
                    {{'insurances.insurances_insurance_please_search_and_select_insurace'|translate}}
                  </span>
                </div>
                <div class="form-group col-md-6 mb-2">
                  <div class=" mb-2 border-bottom">
                    <label class="form-label padding-left fw-bold">{{'insurances.insurances_insurance_policy_no'|translate}}<span class="text-danger">*</span></label>
                    <input type="text" maxlength="25" placeholder="{{'insurances.insurances_insurance_policy_no_placeholder'|translate}}" class="form-control border-0 ltr-component"
                           [(ngModel)]="_addpatientinsurancemodel.policyNumber"
                           (input)="validateInsuranceinfo($event.target,'policyNumber')">
                  </div>
                  <span class="err" id="ins-policy-err" *ngIf="policyNumberError && _addpatientinsurancemodel.policyNumber.length==0">{{'insurances.insurances_insurance_please_enter_policy_no'|translate}}</span>
                </div>
                <div class="form-group col-md-6 mb-2">
                  <div class=" mb-4 border-bottom">
                    <label class="form-label padding-left fw-bold">{{'insurances.insurances_insurance_group_no'|translate}} </label>
                    <input type="text" maxlength="25" placeholder="{{'insurances.insurances_insurance_group_id_placeholder'|translate}}" class="form-control border-0 ltr-component"
                           [(ngModel)]="_addpatientinsurancemodel.groupId"
                           (input)="validateInsuranceinfo($event.target,'groupId')">
                  </div>
                </div>

                <div class="form-group col-md-6" id="relationship">
                  <div class=" form-select mb-2 border-bottom">
                    <label class="form-label padding-left fw-bold">{{'insurances.insurances_relationship'|translate}}<span class="text-danger">*</span></label>
                    <select class="form-control text-capitalize border-0"
                            (change)="ShowSubscriberButton($event)"
                            [(ngModel)]="_addpatientinsurancemodel.relationship" id="main_relationship">
                      <!--<option value="S" disabled selected>Relationship</option>-->
                      <option value="S" selected>{{'insurances.insurances_dropdown_subscriber_option_self'|translate}}</option>
                      <option value="C">{{'insurances.insurances_dropdown_subscriber_option_child'|translate}}</option>
                      <option value="P">{{'insurances.insurances_dropdown_subscriber_option_spouse'|translate}}</option>
                      <option value="O">{{'insurances.insurances_dropdown_subscriber_option_other'|translate}}</option>
                    </select>

                  </div>
                </div>
                <div *ngIf="isShowSubscriberForm" class="col-md-6">
                  <div class="form-group mb-4">
                    <button type="button" (click)="ShowSubscriberForm($event)"
                            class="btn btn-primary">
                      {{'insurances.insurances_add_subscriber'|translate}}
                    </button>
                  </div>
                </div>

              </div>
              <div class="specialist-list" *ngIf="subcriberReq">
                <div class="card mt-0">
                  <div class="card-body">
                    <div class="d-flex flex-sm-row justify-content-between mb-2">
                      <h6 class="font-weight-bold mb-0">
                        {{this._updatesubscriberinfo.guaranT_FNAME | titlecase}}
                        {{this._updatesubscriberinfo.guaranT_LNAME | titlecase}}
                      </h6>
                      <div class="ctabtns">
                        <!--<a class="mr-2" (click)="editSubscriber()">
                          <i title="{{'link.edit'|translate}}"
                             class="fas fa-edit text-dark"></i>
                        </a>-->
                        <a (click)="deleteSubscriber()" class="text-dark">
                          {{'link.delete'|translate}}
                          <!--<i title="{{'link.delete'|translate}}"
                          class="far fa-trash-alt text-danger"></i>-->
                        </a>
                      </div>
                    </div>
                    <div class="mb-1">
                      <span class="text-muted mr-1 font-weight-bold">{{'insurances.insurances_dob'|translate}}</span>
                      <span>{{_updatesubscriberinfo.guarant_dob}}</span>
                    </div>
                    <div>
                      <span class="text-muted mr-1 font-weight-bold">{{'insurances.insurances_subscriber_address'|translate}}</span>
                      <span>
                        {{_updatesubscriberinfo.guaranT_ADDRESS| titlecase}},
                        {{_updatesubscriberinfo.guaranT_CITY | titlecase}}, {{_updatesubscriberinfo.guaranT_STATE}}
                        {{_updatesubscriberinfo.guarant_zip.substring(0, 5)}}

                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <button class="btn btn-primary btncare " type="button" (click)="Add_Insurance_Info_confirmation_model()">{{'insurances.add_insurance'|translate}}​</button>
              </div>
            </div>




          </div>
        </div>
      </ng-container>


      <ng-container *ngIf="InsuranceDetails">
        <div class="container flex-grow-1 overflow-auto">
          <div class="specialist-list">
            <div class="text-right mt-2">
              <button class="btn btn-primary btncare mb-4" *ngIf="InsuranceDetails" (click)="mainInsuranceNew()">{{'button.add_insurance'|translate}}</button>
            </div>
            <div class="text-danger mb-4" *ngIf="isPrimaryInsurancealredyExist && isPrimaryInsuranceInactive">
              {{'insurances.inactiveInsurance_alert'|translate}}
            </div>
            <div class="row">
              <div class="col-lg-6" *ngFor="let insurance of _insurances">
                <div class="card mb-4 pb-3">
                  <div class="card-body p-0">
                    <div class="align-items-center d-flex justify-content-between mb-3">
                      <h5 class="font-weight-bold mb-0">
                        {{ insurance.prI_SEC_OTH_TYPE == 'P' ? ('insurances.insurances_insurance_type_primary' | translate) : (insurance.prI_SEC_OTH_TYPE == 'S' ? ('insurances.insurances_insurance_type_secondary' | translate) : ('insurances.insurances_insurance_type_other' | translate)) }}

                      </h5>
                      <div class="ctabtns">

                        <!--<a (click)="addInsurancemodle(insurance,true,true)" class="text-muted">Edit</a>
                        <span class="text-muted">|</span>-->
                        <a href="javascript:void(0)" class="text-dark" (click)="OpendeleteModel(insurance)">{{'button.delete'|translate}}</a>
                      </div>
                    </div>
                    <div class="specialist-list">
                      <div class="mb-2">
                        <span>{{'insurances.insurances_insurance_info'|translate}}:</span>
                        <span class="text-muted mr-1 font-weight-bold"> {{insurance.inspayeR_DESCRIPTION || 'N/A'}}</span>
                      </div>
                      <div class="mb-2">
                        <span>{{'insurances.insurances_insurance_subscriber_name'|translate}}:</span>
                        <span class="text-muted mr-1 font-weight-bold"> {{insurance.subscriber.trim() || ('insurances.insurances_dropdown_subscriber_option_self'|translate)}}</span>
                      </div>
                      <div class="mb-2">
                        <span>{{'insurances.insurances_insurance_policy_no'|translate}}:</span>
                        <span class="text-muted mr-1 font-weight-bold"> {{insurance.policY_NUMBER || 'N/A'}}</span>
                      </div>
                      <div class="mb-2">
                        <span>{{'insurances.insurances_insurance_group_no'|translate}}:</span>
                        <span class="text-muted mr-1 font-weight-bold"> {{insurance.group_Number || 'N/A'}}</span>
                      </div>
                      <div *ngIf="insurance.prI_SEC_OTH_TYPE == 'P'">
                        <span>{{'insurances.insurance_status'|translate}}:</span>
                        <span class="text-dark mr-1" *ngIf="!isPrimaryInsuranceInactive && !newPrimaryInsuranceAdded"> {{('insurances.active'|translate)|| 'N/A'}}</span>
                        <span class="text-danger mr-1 " *ngIf="isPrimaryInsuranceInactive"> {{('insurances.inactive'|translate)|| 'N/A'}}</span>
                        <span class="text-dark mr-1 " *ngIf="!isPrimaryInsuranceInactive && newPrimaryInsuranceAdded"> {{('insurances.pending'|translate)|| 'N/A'}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>



      <ng-container *ngIf="noInsuranceScreen">
        <div class="container d-flex flex-column" style="min-height: 65vh;">
          <!-- Top buttons -->
          <div class="text-center mt-2" style="font-size:18px">
            <button class="btn btn-primary btncare" (click)="UpdatePatientSelfPayBit('selfpay')">
              {{'PaymentType.selfPay'|translate}}
            </button>
          </div>
          <div class="devider mb-4">
            <span>{{'insurances.insurance_or'|translate}}</span>
          </div>
          <div class="text-center" style="font-size:18px">
            <button class="btn btn-primary btncare mb-4" (click)="addInsuranceBycard();UpdatePatientSelfPayBit('insurance')">
              {{'insurances.add_insurance'|translate}}
            </button>
          </div>

          <!-- Spacer to push the message down and center it -->
          <div class="flex-grow-1 d-flex justify-content-center align-items-center">
            <p class="text-danger text-center" style="font-size: 18px;">
              {{'insurances.insurances_no_insurance_found'|translate}}
            </p>
          </div>
        </div>
      </ng-container>


    </div>


  </div>
</div>


<footer class="p-3">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <button *ngIf="addInsurance" class="btn btn-outline-primary" type="button" (click)="_insurances.length>0? InsuranceDetailsNew():gotoFirstScreen()">{{'button.back'|translate}}</button>
      <button *ngIf="!addInsurance" class="btn btn-outline-primary" type="button" (click)="backClick()">{{'button.back'|translate}}</button>
      <div class="notification-container" (click)="showNotification()" *ngIf="showNotificationIcon">
        <i class="fa fa-bell notification-icon" aria-hidden="true"></i>
        <span class="notification-badge">{{ notificationCount }}</span>
      </div>
      <!--<p class="mb-0">({{pageNum}} {{'generic_text.of'|translate}} {{totalPages}})</p>-->
      <button class="btn btn-primary" type="button" (click)="Next()" *ngIf="!selfpay">{{'button.next'|translate}}</button>
      <button class="btn btn-primary" type="button" (click)="nextClick()" *ngIf="selfpay">{{'button.skip'|translate}}</button>
    </div>
  </div>
</footer>


<!-- Add Insurance Modal -->
<div id="Insurance-Modal" data-backdrop="static" data-keyboard="false"
     class="modal modal-md collapse modal-full-height modal-tabs">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{insurancetype}} {{'insurances.insurances_insurance_type'|translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="showconfirmationmodal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="insurance-tab">
          <ul class="bg-info justify-content-between mb-3 nav nav-pills p-2 rounded text-center"
              id="pills-tab" role="tablist">
            <li class="flex-fill nav-item cursor-pointer" role="presentation">
              <a class="nav-link rounded" [ngClass]="(insurancecat==='P')?'active': ''"
                 (click)="insurancemodel ? '' : ClickInsuranceInfo('P',true)">{{'insurances.insurances_insurance_type_primary'|translate}}</a>

            </li>
            <li class="flex-fill nav-item cursor-pointer" role="presentation">
              <a class="nav-link rounded" [ngClass]="(insurancecat==='S')?'active': ''"
                 (click)="insurancemodel ? '' : ClickInsuranceInfo('S',true)">{{'insurances.insurances_insurance_type_secondary'|translate}}</a>


            </li>
            <li class="flex-fill nav-item cursor-pointer" role="presentation">
              <a class="nav-link rounded" [ngClass]="(insurancecat==='O')?'active': ''"
                 (click)="insurancemodel ? '' : ClickInsuranceInfo('O',true)">{{'insurances.insurances_insurance_type_other'|translate}}</a>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                 aria-labelledby="pills-home-tab">
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="input-group">
                      <div class="dropdown input-icon search  form-floating" ngbDropdown
                           #insuranceDropPopUp="ngbDropdown" style="flex: 2;">
                        <input placeholder="{{'insurances.insurances_insurance_placeholder'|translate}}" autocomplete="off"
                               class="form-control text-left text-capitalize" type="text"
                               id="dropdownMenu2" aria-haspopup="true" aria-expanded="false"
                               [(ngModel)]="insuranceNamePopup"
                               (input)="PatientInsuranceSearch($event,'popup')" ngbDropdownAnchor
                               (focus)="insuranceDropPopUp.open()">
                        <label>{{'insurances.insurances_insurance'|translate}}<span class="text-danger">*</span></label>

                        <div ngbDropdownMenu class="custom-menu" aria-labelledby="dropdownMenu2"
                             [ngClass]="{'d-none': dNoneInsurance}">
                          <button ngbDropdownItem *ngIf="isLoading">
                            <span>{{'insurances.insurances_insurance_loading'|translate}}</span>
                          </button>
                          <button ngbDropdownItem
                                  *ngIf="!isInsuranceData && !isLoading">
                            {{'insurances.insurances_insurance_placeholder'|translate}}
                          </button>
                          <button ngbDropdownItem
                                  *ngIf="filterInsuranceSearch?.length === 0 && !isLoading && isInsuranceData">
                            {{'insurances.insurances_insurance_no_records_found'|translate}}
                          </button>
                          <button ngbDropdownItem *ngFor="let items of filterInsuranceSearch"
                                  (click)="SetInsuranceSearch(items.inspayeR_DESCRIPTION,'popup')">
                            <span class="text-capitalize">
                              {{
items.inspayeR_DESCRIPTION | lowercase
                              }}
                            </span><br />
                            <span class="text-capitalize">
                              {{items.insurancE_ADDRESS|  lowercase }}
                            </span> <br />
                            <span class="text-capitalize">
                              {{items.insurancE_CITY | lowercase }}, {{items.insurancE_STATE}}
                              {{items.insurancE_ZIP.substring(0, 5)}}
                            </span>
                          </button>
                        </div>

                        <!-- <div ngbDropdownMenu class="custom-menu" aria-labelledby="dropdownMenu2">
                            <ul class="list-unstyled symptoms-list item-list mb-0">
                                <li ngbDropdownItem *ngIf="isLoading">
                                    <span>Loading..</span>
                                </li>
                                <li ngbDropdownItem *ngIf="!filterInsuranceSearch && !isLoading">
                                    <span>Search Insurance</span>
                                </li>
                                <li ngbDropdownItem *ngIf="filterInsuranceSearch?.length === 0 && !isLoading && isInsuranceData">
                                    No records found.</li>
                                <li ngbDropdownItem *ngFor="let items of filterInsuranceSearch"
                                    (click)="SetInsuranceSearch(items.inspayeR_DESCRIPTION)">

                                    <span><b>Name:</b>{{items.inspayeR_DESCRIPTION}}</span><br />
                                    <span><b>Phone:</b> {{items.phone}}</span><br />
                                    <span><b>Address:</b> {{items.insurancE_ADDRESS}}</span>

                                </li>
                            </ul>
                        </div> -->


                      </div>
                    </div>
                    <span class="err" id="ins-filter-err" *ngIf="insuranceNameError">
                      {{'insurances.insurances_insurance_please_search_and_select_insurace'|translate}}
                    </span>
                  </div>

                </div>
                <div class="col-md-6" [ngStyle]="{'display' : isNotOCRinsurance ? 'none' : ''}">

                </div>
                <div class="col-md-6" [ngStyle]="{'display' : isNotOCRinsurance ? '' : 'none'}">
                  <div class="form-group  form-floating">

                    <input type="text" maxlength="25" placeholder="{{'insurances.insurances_insurance_policy_no_placeholder'|translate}}**" class="form-control"
                           [(ngModel)]="_addpatientinsurancemodel.policyNumber"
                           (input)="validateInsuranceinfo($event.target,'policyNumber')">
                    <label>{{'insurances.insurances_insurance_policy_no'|translate}} <span class="text-danger">*</span></label>
                    <span class="err" id="ins-policy-err" *ngIf="policyNumberError && _addpatientinsurancemodel.policyNumber.length==0">{{'insurances.insurances_insurance_please_enter_policy_no'|translate}}</span>
                  </div>
                </div>
                <div class="col-md-6" [ngStyle]="{'display' : isNotOCRinsurance ? '' : 'none'}">
                  <div class="form-group form-floating">

                    <input type="text" maxlength="25" placeholder="{{'insurances.insurances_insurance_group_no'|translate}}" class="form-control"
                           [(ngModel)]="_addpatientinsurancemodel.groupId"
                           (input)="validateInsuranceinfo($event.target,'groupId')">
                    <label>{{'insurances.insurances_insurance_group_no'|translate}} </label>
                  </div>
                </div>
                <div class="col-md-6" [ngStyle]="{'display' : isNotOCRinsurance ? '' : 'none'}">
                  <div class="form-group form-select form-floating">

                    <select id="dd-rel" class="form-control cursor-pointer"
                            (change)="ShowSubscriberButton($event)"
                            [(ngModel)]="_addpatientinsurancemodel.relationship">
                      <option value="C">{{'insurances.insurances_dropdown_subscriber_option_child'|translate}}</option>
                      <option value="P">{{'insurances.insurances_dropdown_subscriber_option_spouse'|translate}}</option>
                      <option value="S">{{'insurances.insurances_dropdown_subscriber_option_self'|translate}}</option>
                      <option value="O">{{'insurances.insurances_dropdown_subscriber_option_other'|translate}}</option>
                    </select>
                    <label>{{'insurances.insurances_relationship'|translate}} <span class="text-danger">*</span></label>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="isShowSubscriberForm"
                     [ngStyle]="{'display' : isNotOCRinsurance ? '' : 'none'}">
                  <div class="form-group">
                    <button type="button" (click)="ShowSubscriberForm($event)"
                            class="btn btn-primary">
                      {{'insurances.insurances_add_subscriber'|translate}}
                    </button>
                  </div>
                </div>
              </div>
              <div class="specialist-list" *ngIf="subcriberReq"
                   [ngStyle]="{'display' : isNotOCRinsurance ? '' : 'none'}">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-sm-row justify-content-between mb-2">
                      <h6 class="font-weight-bold mb-0">
                        {{this._updatesubscriberinfo.guaranT_FNAME}},
                        {{this._updatesubscriberinfo.guaranT_LNAME}}
                      </h6>
                      <div class="ctabtns">
                        <a class="mr-2" (click)="editSubscriber()">
                          <i title="{{'link.edit'|translate}}"
                             class="fas fa-edit text-dark"></i>
                        </a>
                        <a (click)="deleteSubscriber()">
                          <i title="{{'link.delete'|translate}}"
                             class="far fa-trash-alt text-danger"></i>
                        </a>
                      </div>
                    </div>
                    <div class="mb-1">
                      <span class="text-muted mr-1 font-weight-bold">{{'insurances.insurances_dob'|translate}}</span>
                      <span>{{_updatesubscriberinfo.guarant_dob}}</span>
                    </div>
                    <div>
                      <span class="text-muted mr-1 font-weight-bold">{{'insurances.address'|translate}}</span>
                      <span>{{_updatesubscriberinfo.guaranT_ADDRESS}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary " (click)="showconfirmationmodal()">{{'button.close'|translate}}</button>
        <button type="button" class="btn btn-primary " [ngStyle]="{'display' : isNotOCRinsurance ? '' : 'none'}"
                (click)="Add_Insurance_Info_confirmation_model()">
          {{'button.verify'|translate}}
        </button>
        <button type="button" class="btn btn-primary " [ngStyle]="{'display' : isNotOCRinsurance ? 'none' : ''}"
                (click)="add_insurance_manual()">
          {{'button.next'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Subscriber Modal -->

<div id="Subscriber-Modal" data-backdrop="static" data-keyboard="false" class="modal modal-md collapse">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'insurances.insurances_add_subscriber'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="CloseSubscriberModel()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="insurance-tab">
          <div class="form-row">
            <div class="form-group col-md-6">
              <div class=" mb-2 border-bottom">
                <label class="form-label padding-left fw-bold">{{'insurances.insurances_subscriber_first_name'|translate}}<span class="text-danger">*</span></label>
                <input type="text" class="form-control border-0 ltr-component" placeholder="{{'insurances.insurances_subscriber_enter_first_name_placeholder'|translate}}" maxlength="35"
                       [(ngModel)]="_updatesubscriberinfo.guaranT_FNAME"
                       (change)="_updatesubscriberinfo.guaranT_FNAME.length > 1 ? _firstNameReq=false :_firstNameReq=true"
                       (input)="validateName($event.target,'subscriber','first')">
              </div>
              <span class="err" *ngIf="_firstNameReq">
                {{'insurances.insurances_subscriber_enter_first_name'|translate}}
              </span>
            </div>
            <div class="form-group col-md-6">
              <div class="mb-2 border-bottom">
                <label class="form-label padding-left fw-bold">{{'insurances.insurances_subscriber_last_name'|translate}}<span class="text-danger">*</span></label>
                <input type="text" placeholder="{{'insurances.insurances_subscriber_enter_last_name_placeholder'|translate}}" class="form-control border-0 ltr-component" maxlength="35"
                       [(ngModel)]="_updatesubscriberinfo.guaranT_LNAME"
                       (change)="_updatesubscriberinfo.guaranT_LNAME.length > 1 ? _lastNameReq=false :_lastNameReq=true"
                       (input)="validateName($event.target,'subscriber','last')">
              </div>
              <span class="err" *ngIf="_lastNameReq">
                {{'insurances.insurances_subscriber_enter_last_name'|translate}}
              </span>
            </div>
            <div class="form-group col-md-12">

              <div class=" position-relative  mb-2 border-bottom">
                <label class="form-label padding-left fw-bold">{{'insurances.insurances_subscriber_date_of_birth'|translate}} </label>
                <input type="date" class="form-control border-0 ltr-component" value="{{'insurances.insurances_subscriber_enter_dob'|translate}}" placeholder="Date of Birth"
                       [max]="maxDate" [(ngModel)]="_updatesubscriberinfo.guarant_dob"
                       min="{{'1901-01-01' | date:'yyyy-MM-dd'}}" (focusout)="checkValidDate($event)"
                       (change)="onChangeDate($event)">
              </div>
              <span *ngIf="isDateError" class="err">{{'insurances.insurances_subscriber_date_of_birth_error'|translate}}</span>
            </div>


            <!-- Smarty APi address Start -->
            <div class="form-group  col-md-12">
              <div class="mb-2 border-bottom">
                <label class="fw-bold form-label"> {{'insurances.insurances_subscriber_address'|translate}}<span class="text-danger">*</span></label>
                <div class="dropdown" ngbDropdown #addressDrop="ngbDropdown">
                  <input placeholder="{{'insurances.insurances_subscriber_address_placeholder'|translate}}" class="form-control text-left text-capitalize border-0 ltr-component" type="text"
                         ngbDropdownAnchor (focus)="addressDrop.open()" id="searchlanguagedropdown" aria-haspopup="true" aria-expanded="false"
                         (change)="_updatesubscriberinfo.guaranT_ADDRESS.length > 1 ? addressReq=false :addressReq=true" (input)="ValidateAddress($event.target,'subscriber','address')"
                         [(ngModel)]="_updatesubscriberinfo.guaranT_ADDRESS"
                         (input)="SearchAdressBySmartyAPi($event)" autocomplete="off">

                  <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchaddressdropdown" [ngClass]="{'d-none': dNoneAddress}">
                    <button ngbDropdownItem *ngIf="isLoading">
                      {{'updateinfo.language_loading'|translate}}
                    </button>
                    <!--<button ngbDropdownItem *ngIf="!isLoading && !addressOptions">
                    {{'updateinfo.language_search'|translate}}</button>-->
                    <button *ngIf="addressOptions?.length == 0 && !isLoading" ngbDropdownItem>
                      {{'updateinfo.language_no_records_found'|translate}}
                    </button>
                    <button ngbDropdownItem *ngFor="let address of addressOptions"
                            (click)="setAddressOption(address)">

                      {{ address.entries && address.entries > 1 ? address.streetLine + ' ' + address.secondary + '... ' +  address.city + ', ' + address.state + ' ' +  address.zipcode + " ( +" + address.entries + " addresses )" : address.streetLine + (address.secondary ? ' ' + address.secondary : '') + ' ' + address.city + ', ' +  address.state + ' ' +  address.zipcode }}

                    </button>
                  </div>
                </div>

              </div>
              <span class="err" id="c-address-line1-err" *ngIf="addressReq">
                {{'insurances.insurances_subscriber_address_required'|translate}}
              </span>
            </div>

            <!-- Smarty APi address End -->
            <!--<div class="col-md-12">
                <div class="form-group  mb-4 border-bottom">

                    <input type="text" placeholder="{{'insurances.insurances_subscriber_address'|translate}}*" class="form-control" maxlength="50"
                        (change)="_updatesubscriberinfo.guaranT_ADDRESS.length > 1 ? addressReq=false :addressReq=true"
                        (input)="ValidateAddress($event.target,'subscriber','address')"
                        [(ngModel)]="_updatesubscriberinfo.guaranT_ADDRESS">
                    <label>{{'insurances.insurances_subscriber_address'|translate}} <span class="text-danger">*</span></label>
                    <span class="err" *ngIf="addressReq">
                      {{'insurances.insurances_subscriber_address_required'|translate}}
                    </span>
                </div>
            </div>-->


            <div class="form-group col-md-4">
              <div class=" mb-2 border-bottom">
                <label class="form-label padding-left fw-bold">{{'insurances.insurances_subscriber_zip'|translate}}<span class="text-danger">*</span></label>
                <input type="text" class="form-control border-0 ltr-component" maxlength="10" id="s-zip" placeholder="{{'insurances.insurances_subscriber_zip_placeholder'|translate}}"
                       [(ngModel)]="_updatesubscriberinfo.guarant_zip"
                       (input)="onFocusOutZIPSubsciber($event.target,0)" />
              </div>
              <span class="err" id="s-zip-err" *ngIf="isZipCodeNotValidSuubscriberInfo">
                {{'insurances.insurances_subscriber_enter_valid_zip_code'|translate}}
              </span>
              <span class="err" *ngIf="zipReq && _updatesubscriberinfo.guarant_zip?.length === 0">
                {{'insurances.insurances_subscriber_zip_required'|translate}}
              </span>
            </div>
            <div class="form-group  col-md-4">
              <div class=" form-select mb-2 border-bottom">
                <label class="form-label padding-left fw-bold">{{'insurances.insurances_subscriber_city'|translate}}<span class="text-danger">*</span></label>
                <select class="form-control border-0" (change)="onFocusOutCity($event)"
                        [(ngModel)]="_updatesubscriberinfo.guaranT_CITY"
                        [attr.disabled]="_updatesubscriberinfo.guaranT_CITY ? null : true">
                  <option *ngFor="let city of _cityandstateList" [value]="city.cityName">
                    {{city.cityName}}
                  </option>
                </select>

              </div>
            </div>
            <div class="form-group col-md-4">
              <div class="  mb-2 border-bottom">
                <label class="form-label padding-left fw-bold">{{'insurances.insurances_subscriber_state'|translate}}<span class="text-danger">*</span></label>
                <input type="text" class="form-control border-0 ltr-component"
                       [(ngModel)]="_updatesubscriberinfo.guaranT_STATE" [attr.disabled]="true" />

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary " data-dismiss="modal"
                (click)="CloseSubscriberModel()">
          {{'button.close'|translate}}
        </button>
        <button type="button" class="btn btn-primary " (click)="ValidateSubscriber()">{{subSAction}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal modal-md collapse" id="Captured-Modal" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'insurances.insurances_capture_image'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="closeCaptureCard('close')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" #scrollCaptureInsurance>
        <p class="text-center">
          {{'insurances.insurances_capture_image_text'|translate}}
        </p>
        <div class="bg-light p-3 rounded">
          <div class="row text-center">
            <div class="col-md-6 mb-3 mb-md-0">
              <div class="mb-2"><img class="img-fluid cap-img" [src]="defaultImagefront" onclick="document.getElementById('fileFront').click();" style="cursor:pointer"></div>
              <button type="button" class="btn btn-primary upload-btn px-0">
                <input type="file" id="fileFront" class="d-none" (change)="onChangeFileFront($event)"
                       accept="image/png, image/gif, image/jpeg,image/jpg">
                <label for="fileFront">
                  <span class="file-button">
                    {{'insurances.insurances_capture_add_card_front'|translate}} <i class="fas fa-camera text-white ml-2"></i>
                  </span>
                </label>
              </button>
              <div class="err" *ngIf="isRequireFrontCard">{{'insurances.insurances_capture_add_card_front_is_required'|translate}}</div>
              <!-- <small class="text-primary d-block  mt-2" *ngIf="fileObjFront"><i class="fa fa-image mr-2"></i>{{fileObjFront.name}}</small> -->
            </div>
            <div class="col-md-6">
              <div class="mb-2"> <img class="img-fluid cap-img" [src]="defaultImageback" onclick="document.getElementById('fileBack').click();" style="cursor:pointer"></div>
              <button type="button" class="btn btn-primary upload-btn px-0">
                <input type="file" id="fileBack" class="d-none" (change)="onChangeFileBack($event)"
                       accept="image/png, image/gif, image/jpeg,image/jpg">
                <label for="fileBack">
                  <span class="file-button">
                    {{'insurances.insurances_capture_add_card_back'|translate}} <i class="fas fa-camera text-white ml-2"></i>
                  </span>
                </label>
              </button>
              <div class="err" *ngIf="isRequireBackCard">{{'insurances.insurances_capture_add_card_back_is_required'|translate}}</div>
              <!-- <small class="text-primary d-block mt-2" *ngIf="fileObjBack"><i class="fa fa-image mr-2"></i>{{fileObjBack.name}}</small> -->
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <!--<a class="mr-auto text-center" (click)="addInsuranceManullay()">{{'insurances.insurances_add_insurance_manually'|translate}}</a>-->
        <!--<button type="button" class="btn btn-outline-primary " data-dismiss="modal"
                (click)="closeCaptureCard('close')">
          {{'button.close'|translate}}
        </button>-->
        <button type="button" class="btn btn-primary " (click)="callOCRinsuranceService()">{{'button.done'|translate}}</button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="incorrectinfoocr-model">
  <!-- <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Breeze Check-in</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <p class="text-left mb-0">Service is not available, please try later. Please {{insurancetype | lowercase}} insurance manully. </p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary " data-dismiss="modal" (click)="showCaptureModel()">Close</button>
              <a type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory" class="btn btn-primary " (click)="addInsuranceManullay()">OK</a>
          </div>
      </div>
  </div> -->

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'insurances.insurances_no_insurance_found'|translate}}</strong></h5>
        <p class="mb-3">{{insurancetype}} {{'insurances.insurances_insurance_manually'|translate}}</p>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                (click)="showCaptureModel()">
          {{'button.close'|translate}}
        </button>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory"
                class="btn btn-primary" (click)="addInsuranceManullay()">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="insuranceConfirmation">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Breeze Check-in</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="text-left mb-0">Please verify your Insurance Card details before selecting Save</p>
            </div>
            <div class="modal-footer">
                !-- <button type="button" class="btn btn-outline-primary " data-dismiss="modal">Close</button> --
                <a type="button" data-toggle="modal" data-dismiss="modal" id="closeDeleteFamilyHistory" class="btn btn-primary ">OK</a>
            </div>
        </div>
    </div>
</div> -->

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="insuranceclosemodel">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <!-- <h5 class="font-weight-bolder mb-2 text-danger"><strong>Are you sure you want to proceed?</strong></h5> -->
        <h5 class="font-weight-bolder mb-2 text-danger"><strong>{{'insurances.insurances_insurance_you_will_lose_the_updated_information'|translate}}</strong></h5>
        <!-- <p class="mb-3">You will loose all insurance information if you close this screen. </p> -->
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                (click)="noAgree()">
          {{'button.no'|translate}}
        </button>
        <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary "
                (click)="ClearInsuranceInfo()">
          {{'button.yes'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="insurancesavemodal">
  <!-- <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Breeze Check-in</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <p class="text-left mb-0">Are you sure you want to {{insurancetype}} this record?</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary " data-dismiss="modal">No</button>
              <a type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary " (click)="Addinsurance()">Yes</a>
          </div>
      </div>
  </div> -->

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>
            {{'insurances.insurances_insurance_are_you_sure_you_want_to'|translate}}
            {{ insurancetype | lowercase }}
            {{'insurances.insurances_insurance_this_record'|translate}}
          </strong>
        </h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                (click)="noAgree()">
          {{'button.no'|translate}}
        </button>
        <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary "
                (click)="Addinsurance()">
          {{'button.yes'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="insurancedeletemodel">
  <!-- <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Breeze Check-in</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <p class="text-left mb-0">Are you sure you want to delete this record?</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary " data-dismiss="modal">No</button>
              <a type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary " (click)="DeleteInsurance()">Yes</a>
          </div>
      </div>
  </div> -->

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'insurances.insurances_insurance_are_you_sure_you_want_to_delete_this_record'|translate}}</strong></h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal">{{'button.no'|translate}}</button>
        <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary rbtn"
                (click)="DeleteInsurance()">
          {{'button.yes'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="PrimeryinsuranceNotAvailable">
  <!-- <div class="modal-dialog">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Breeze Check-in</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <p class="text-left mb-0">Are you sure you want to delete this record?</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-outline-primary " data-dismiss="modal">No</button>
              <a type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary " (click)="DeleteInsurance()">Yes</a>
          </div>
      </div>
  </div> -->

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong> {{'insurances.insurances_insurance_enter_primary_insurance_first'|translate}}</strong></h5>
        <!-- <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal">No</button> -->
        <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary"
                (click)="ToggleInsuranceModel(true)">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="notofication-modal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3"><strong> {{'insurances.pcp_mismatch'|translate}} </strong></h5>

        <h5 class="mb-4">
          {{'insurances.text1'|translate}} {{patientpersonalinfo.FIRSTNAME |titlecase}}, {{'insurances.text2'|translate}} {{dr}}{{providerFname}}
          {{providerLname}}{{np}} {{'insurances.text3'|translate}} {{dr}}{{providerFname}}
          {{providerLname}}{{np}}.
        </h5>
        <button type="button" class="btn btn-primary" data-dismiss="modal">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
